export default {
  GET_APPLICATION: 'getApplication',
  GET_LOCATION: 'getLocation',
  GET_ROL: 'getRol',
  GET_RESULT: 'getResult',
  GET_TABLE_CONFIG: 'getTableConfig',
  GET_FILTER: 'getFilter',
  GET_CURRENT_FILTER: 'getCurrentFilter',
};
